module.exports = __webpack_public_path__ + "img/starting.f05d8459.webp";